/**
 * WordPress dependencies
 */
import { createContext, useContext } from '@wordpress/element';

/**
 * Internal dependencies
 */

export const TabsContext = createContext(undefined);
TabsContext.displayName = 'TabsContext';
export const useTabsContext = () => useContext(TabsContext);